import React from "react";
import Label from "./Label";

const RadioGroup = ({
  id = "r-groups",
  title,
  description,
  options,
  onChange,
  currentValue,
  horizontal,
  labelClasses = "",
}) => {
  if (!options || !options.length) {
    throw new Error("missing options");
  }

  return (
    <div className="mb-1">
      {title ? (
        <Label
          className={`text-base font-medium text-gray-900 ${labelClasses}`}
        >
          {title}
        </Label>
      ) : null}
      {description ? (
        <p className="text-sm leading-5 text-gray-500">{description}</p>
      ) : null}
      <fieldset className="mt-4" id={id}>
        <div
          className={horizontal ? "flex space-x-4" : "flex flex-col space-y-4"}
        >
          {options.map(({ name, value }) => (
            <div
              onClick={() => {
                onChange(value);
              }}
              key={value}
              className="flex items-center cursor-pointer"
            >
              <input
                name={id}
                readOnly
                id={value}
                type="radio"
                checked={currentValue === value}
                className="focus:ring-am-500 h-4 w-4 cursor-pointer text-am-600 border-gray-300"
              />
              <label
                htmlFor={value}
                className="ml-3 block text-sm font-medium cursor-pointer text-gray-700"
              >
                {name}
              </label>
            </div>
          ))}
        </div>
      </fieldset>
    </div>
  );
};

export default RadioGroup;
